import * as XLSX from 'xlsx'
import { FormatDateForDB } from './util'

export const columnsToTemplate = (columns, fileName = 'template.xlsx') => {
  let colArray = []
  for (let i = 0; i < columns.length; i++) {
    let column = columns[i]
    if (column.spreadSheetColumns) {
      colArray = colArray.concat(column.spreadSheetColumns)
    } else if (column.inSpreadsheet) {
      colArray.push(columns[i].headingText)
    }
  }

  writeSpreadsheet(colArray)
}

export const writeSpreadsheet = (colArray, fileName = 'template.xlsx') => {
  let workbook = XLSX.utils.book_new()
  let sheet = XLSX.utils.aoa_to_sheet([colArray])
  //keep heading text from being cut off
  sheet['!cols'] = colArray.map((heading) => ({ wch: heading.length }))
  XLSX.utils.book_append_sheet(workbook, sheet)
  XLSX.writeFile(workbook, fileName)
}

export const sheetToTableData = (columns, sheet) => {
  let sheetJson = XLSX.utils.sheet_to_json(sheet)
  let fieldMap = {}
  if (sheetJson.length > 0) {
    let columnsToMap = [...columns].filter((col) => col.inSpreadsheet)
    Object.keys(sheetJson[0]).map((key) => {
      let matchingCols = columns.filter((col) => col.headingText == key)
      if (matchingCols.length > 0) {
        fieldMap[key] = matchingCols[0].accessor ? matchingCols[0].accessor : matchingCols[0].id
      }
    })
    columnsToMap = columnsToMap.filter((col) => !Object.prototype.hasOwnProperty.call(fieldMap, col.headingText))
    //handle lookup fields
    for (let c of columnsToMap) {
      if (c.spreadSheetColumns) {
        let idCol = c.spreadSheetColumns[0]
        let labelCol = c.spreadSheetColumns[1]
        fieldMap[idCol] = c.accessor ? c.accessor : c.id
        fieldMap[labelCol] = (c.accessor ? c.accessor : c.id) + '_label'
      }
    }
  }

  let data = sheetJson.map((row, i) => {
    let toReturn = {}
    Object.keys(row).map((c) => {
      if (fieldMap[c]) {
        toReturn[fieldMap[c]] = row[c] instanceof Date ? FormatDateForDB(row[c]) : row[c]
      }
    })
    toReturn.row_num = i + 1
    return toReturn
  })
  return data
}
